import Proposal from "@/models/Proposal/Proposal.js";

export default function AreAllProposalProductsCheckAcceptedQuery(id) {
    const data = Proposal.query().with('groupProducts.checkState').find(id);

    for (const product of data.groupProducts || []) {
        if (!product.checkState?.IsAccepted()) {
            return false;
        }
    }

    return true;
}
